import { presets } from '../audio/presets.js';

export function buildPresetSelector(selectEl, state) {
  // Populate dropdown
  for (const name of Object.keys(presets)) {
    const option = document.createElement('option');
    option.value = name;
    option.textContent = name;
    selectEl.appendChild(option);
  }

  // Load preset on change
  selectEl.addEventListener('change', () => {
    const preset = presets[selectEl.value];
    if (preset) {
      state.loadPreset(preset);
      state.set('currentPreset', selectEl.value);
    }
  });

  // Sync with state
  state.subscribe('currentPreset', (val) => {
    selectEl.value = val;
  });
}

export function loadDefaultPreset(state) {
  const defaultName = state.get('currentPreset') || 'Event Horizon';
  const preset = presets[defaultName];
  if (preset) {
    state.loadPreset(preset);
  }
}
